<!--
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2024-06-12 15:44:17
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2024-07-22 13:48:23
 * @FilePath: \website\src\components\element\cpt-iframe.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div style="width: 100%;height: 100%" class="iframe-component">
    <div v-if="design" class="activeMask" />
    <iframe loading="lazy" ref="iframe" width="100%" height="100%" :src="url" :key="key" allowfullscreen="true"
      webkitallowfullscreen="true" mozallowfullscreen="true" />
  </div>
</template>

<script>
import { getDataJson, pollingRefresh, getDefaultValue, hasNonEmptyValues, hasProperty } from "@/utils/refresh-cpt-data";
// import { mixinsCom } from "@/mixins/globalAllComps";
export default {
  name: "cpt-iframe",
  inject: ['showContextMenu'],
  props: {
    option: Object,
    design: Boolean,
    current: Object,
    components: Array,
    cacheComponents: Array,
    refMap: Object
  },
  // mixins: [mixinsCom],
  computed: {
    // iptVal() {  //组件绑定的属性
    //   console.log("======textres====",this.option.cptDataForm.resData);
    //   if(this.option.cptDataForm.resData){
    //       return this.processData(this.option.cptDataForm, this.option.cptDataForm.resData);
    //   }
    // },
    iptVal: {  //组件绑定的属性
      get() {
        if (this.option.cptDataForm.resData) {
          return this.processData(this.option.cptDataForm, this.option.cptDataForm.resData);
        }
      },
      set(newValue) {
        this.option.cptDataForm.resData = { value: newValue }
      }
    },

    dataReload() {
      return this.option.attribute.globalDataReload || [0]
    }
  },
  data() {
    return {
      uuid: null,
      alarmed: false,
      newData: "",
      jsFunFlag: false,
      url: '',
      key: new Date().getTime(),
      paras: {}
    }
  },
  watch: {
    url(val) {
      if (val) this.key = new Date().getTime()
    },
    "current.cptShow"(val) {
      if (val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
    "option.attribute.hideCompInTab"(val) {
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    }
  },
  created() {
    if (!this.option.attribute.globalDataReload) {
      this.option.attribute.globalDataReload = [0]
    }
    const defaultValue = getDefaultValue(this.option.attribute)
    if (defaultValue) {
      this.url = defaultValue
    }
    this.uuid = require('uuid').v1();
    if (!this.option.attribute.cptTableData) {
      this.option.attribute.cptTableData = [{ "name": "值", "value": "", "namekey": "value" }];
    }
    if (!this.option.cptDataForm) {
      this.option.cptDataForm = {
        dataText: '{"value":""}',
        dataSource: 1,
        pollTime: 0,
        apiUrl: '/url',
        sql: 'select id from test limit 1'
      };
    }
    // console.log('重新渲染了')
    if (this.dataReload.includes(0)) {
      this.refreshCptData();
    }
  },
  mounted() {
    this.$nextTick(() => {
      let iframe = this.$refs.iframe;
      let vm = this;
      console.log(iframe, 'ddd')
      if (iframe)
        iframe.onload = function () {
          if (!iframe.contentDocument) return;
          if (vm.design) {
            //监听鼠标右键事件
            iframe.contentDocument.addEventListener('contextmenu', function (e) {
              //阻止默认行为
              e.preventDefault();
              //向主进程发送消息
              vm.showContextMenu(e, 'iframe')
            }, false);
          }
          if (vm.paras && vm.paras != '{}') {
            if (Object.keys(vm.paras).length > 0) {
              setTimeout(() => {
                vm.sendMessageToIframe(vm.paras)
                // 3秒数据加载太慢  改为500
              }, 2000)
            }
          }
        };
    })
  },

  methods: {
    refreshCptData(cptDataForm = this.option.cptDataForm, paras) {
      pollingRefresh(this.uuid, cptDataForm, () => {
        this.loadData(cptDataForm, paras)
      })
    },
    loadData(cptDataForm, paras) {
      const that = this;

      getDataJson(cptDataForm, paras, (res) => {
        that.newData =
          cptDataForm.dataSource == "4" && hasProperty(res, "jsFunction")
            ? res.resStr
            : res; //相同数据集只调用一次接口原因
        // that.jsFunFlag =
        //   cptDataForm.dataSource == "4" && hasProperty(res, "jsFunction")
        //     ? res.jsFunction
        //     : false; //相同数据集只调用一次接口原因
        if (!that.jsFunFlag) that.paras = paras;
        that.processData(cptDataForm, that.newData, that.jsFunFlag);
      });
    },

    processData(cptDataForm, res, jsFunFlag, isFromGrid) {
      let getFatherUrlParams = this.option.attribute?.getFatherUrlParams;
      // 64b37af1-32b8-11ef-83b0-3904d0fcd310
      console.log(this.current.id, 'plplplplplplp')
      // 第一层判断 如果选择数据集
      if (cptDataForm.dataSource == '4') {
        // if (this.current.cptOption.interaction.fatherGridId && isFromGrid != 'ninegrid') return
        // 第二层判断 ，如果没有配转换脚本
        // if (jsFunFlag) { // 没有全部配置映射字段
        //判断此控件在九宫格里面就不请求数据


        if (hasNonEmptyValues(this.option.attribute.cptTableData)) {
          const dataKey = this.option.attribute.cptTableData;
          // 创建一个新的数组用于存储结果
          let newres = [];
          let newObj = { ...res[0] };
          // 如果dataKey中的value有值并且在newObj对象中有对应的值
          // if (dataKey[0].value && newObj[dataKey[0].value]) {
          newObj[dataKey[0].namekey] = newObj[dataKey[0].value];
          // }
          newres.push(newObj);
          this.url = newres[0].value;
        }
        // } else { // 如果配置了转换脚本
        //   this.iptVal = res.value;
        // }
      } else { // 不是数据集类型，是静态数据
        if (this.url && this.url == res.value) {
        } else {
          this.url = res.value;
        }
        this.$nextTick(() => {
          if (!this.option.attribute.hideCompInTab) {
            this.sendMessageToIframe(this.paras)
          }
        })
      }

      if (getFatherUrlParams == '1') {
        let urlParams = this.url.includes('?') ? location.search.replace('?', '&') : location.search
        this.url = this.url + urlParams
      }

      console.log(this.url,'qwdijqwidqwijijqwdijdqwijdjiqdijwqdi');
      
      // 添加iframe链接唯一key
      // this.url = `${this.url}${this.url.includes('?') ? '&' : '?'}reloadTimeKey=${new Date().getTime()}`
      // console.log(this.url,res.value,'qwdijqwidqwijijqwdijdqwijdjiqdijwqdi222222');

    },
    getValue() {
      return this.cptData?.value
    },
    setValue(value) {
      console.log('text setValue', value)
      this.cptData.value = value
      console.log(this.newData)
    },
    sendMessageToIframe(message) {
      let iframe = this.$refs.iframe;
      console.log(iframe?.contentWindow, message, '?啊啊啊??')
      if (iframe?.contentWindow && typeof message != 'undefined') {
        iframe.contentWindow.postMessage(JSON.stringify(message), '*');
      }
    },
    iframeReload() {
      // this.$refs.iframe
      this.url = this.$refs.iframe.src
    }
  },
}
</script>

<style scoped>
.activeMask {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1801;
}

.iframe-component iframe {
  border: 0;
}
</style>
